import React from 'react'
import PropTypes from 'prop-types'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'

const BreadPaymentsBanner = ({ dynamicContent }) => <HTMLContainer content={ dynamicContent } id="breadPaymentsBanner" />

export default BreadPaymentsBanner

BreadPaymentsBanner.propTypes = {
  dynamicContent: PropTypes.string
}

